var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-seamless-scroll',{staticClass:"service-enterprise",attrs:{"data":_vm.data,"class-option":_vm.classOption}},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('img',{attrs:{"src":item,"alt":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }